export interface User {
  id: string;
  roles: Array<{
    role: {
      id: string;
      name: string;
    };
  }>;
}

export interface NoteNotification {
  serviceRequests: boolean;
  properties: boolean;
  suites: boolean;
  assets: boolean;
  inventoryItems: boolean;
  contacts: boolean;
}

export interface SettingsState {
  // Account settings
  id: string;
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  profileImage: string;
  selectedProfileImage: File[] | null;
  calendarLink?: string;
  calendlyAPIKey?: string;

  // Company settings
  companyName: string | null;
  companyAddress: string | null;
  companyCity: string | null;
  companyState: string | null;
  companyZip: string | null;
  companyEmail: string | null;
  companyPhone: string | null;
  companyLogo: string | null;
  selectedCompanyLogo: File[] | null;

  // Notification settings
  allowEmail: boolean;
  allowStatus: boolean;
  allowNotes: boolean;
  noteNotification: NoteNotification;
}

export interface SystemLevelNotification {
  id: string;
  name: string;
  description: string;
  isActive: boolean;
}

export interface UserProfileSettings {
  id?: string | number;
  firstname?: string;
  lastname?: string;
  email?: string;
  phone?: string;
  profileImage?: string;
  selectedProfileImage?: File[] | null;
  calendarLink?: string;
  calendlyAPIKey?: string;
  allowEmail: boolean;
  allowStatus: boolean;
  allowNotes: boolean;
  noteNotification: NoteNotification;
}

export interface ValidationErrors {
  errors?: boolean;
  firstname?: string;
  lastname?: string;
  email?: string;
  phone?: string;
  companyName?: string;
  companyAddress?: string;
  companyEmail?: string;
  companyPhone?: string;
  companyCity?: string;
  companyState?: string;
  companyZip?: string;
}

export interface CompanySettings {
  companyName: string;
  companyAddress: string;
  companyCity: string;
  companyState: string;
  companyZip: string;
  companyEmail: string;
  companyPhone: string;
  companyLogo: string;
  selectedCompanyLogo: File[] | null;
}

export const USER_ROLE_NAMES = {
  PROPERTY_DEVELOPER: 'Property Developer',
  SERVICE_PROVIDER: 'Service Provider',
  HOME_OWNER: 'Home Owner',
  OCCUPANT: 'Occupant',
  ADMIN: 'Admin',
  SUPER_ADMIN: 'Super Admin',
  SERVICE_MANAGER: 'Service Manager',
  STRATA_MANAGER: 'Strata Manager',
} as const;

export const PHONE_REGEX = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
export const EMAIL_REGEX =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;